/** The route hash that opens the printable spirit list, e.g. #spirit-list/builtin:spirits.
 *  Kept apart from SpiritList.tsx so main.tsx can check the route without loading the page. */
export const isSpiritListRoute = () => location.hash.startsWith("#spirit-list");
